// 项目管理
import type { RouteRecordRaw } from 'vue-router'
import { withAccessKeyMeta } from '@/router/access-map'
import { defaultLayout } from '@/router/base'

const routes: RouteRecordRaw[] = [
  {
    path: '/teams',
    name: 'Teams',
    component: defaultLayout,
    meta: withAccessKeyMeta('teams', {
      locale: 'common.menus.teams',
      requiresAuth: true,
      icon: 'teams',
      hideChildrenInMenu: true,
      activeMenu: 'Teams',
      order: 5,
    }),
    children: [
      {
        path: '',
        name: 'TeamsIndex',
        component: () => import('@/views/teams/index.vue'), // 客户列表
        meta: {
          locale: 'common.menus.teams',
          requiresAuth: true,
          roles: ['*'],
          activeMenu: 'Teams',
          isTopMenu: true,
        },
      },
      {
        path: 'objective',
        name: 'TeamsObjective',
        component: () => import('@/views/objective/index.vue'), // 目标管理
        meta: {
          locale: 'common.menus.objective',
          requiresAuth: true,
          roles: ['*'],
          activeMenu: 'Teams',
          isTopMenu: false,
        },
      },
      {
        path: 'role',
        name: 'TeamsRole',
        component: () => import('@/views/permission/role.vue'), // 角色管理
        meta: {
          locale: 'common.menus.role',
          requiresAuth: true,
          roles: ['*'],
          activeMenu: 'Teams',
          isTopMenu: false,
        },
      },
    ],
  },
]

export default routes
